export const translations = {
  pl: {
    nav: {
      home: "Strona główna",
      gallery: "Galeria",
      about: "O mnie",
      exhibitions: "Wystawy",
      contact: "Kontakt",
    },
    common: {
      viewMore: "Zobacz więcej",
      backToTop: "Wróć na górę",
      seeCollection: "Zobacz kolekcję",
      contactStudio: "Skontaktuj się z pracownią",
      readStory: "Poznaj moją historię",
      talkAboutArt: "Porozmawiajmy o sztuce",
      askAbout: "Zapytaj o obraz",
      year: "Rok",
      medium: "Technika",
      category: "Kategoria",
    },
    hero: {
      eyebrow: "Piotr Gonzaga Myszkowski",
      h1Line1: "Sztuka,",
      h1Line2: "która oddycha.",
      lead:
        "Obrazy, które dają wnętrzom światło, energię i życie. Minimalizm, czysta forma, kolor bez kompromisu.",
      ctaPrimary: "Kolekcja",
      ctaSecondary: "Pracownia",
      paris_caption: "Ukłon dla Paryża · olej na płótnie",
    },
    manifesto: {
      overline: "Manifest",
      lines: [
        "Sztuka kosztuje życie.",
        "Tworzenie to oddychanie.",
        "Domy bez sztuki są smutne.",
        "Never give up.",
      ],
    },
    featured: {
      overline: "Praca w pracowni",
      title: "Orange Zone",
      meta: "Olej na płótnie · 2024",
    },
    about_block: {
      overline: "O artyście",
      title: "Prawdziwa sztuka kosztuje życie.",
      p1:
        "Swojej twórczości poświęciłem wszystko. Przez ponad ćwierć wieku przeszedłem długą drogę — od czasów, gdy malowałem wystawę przy odciętym prądzie, aż po dzisiejsze dni, gdy moje prace zdobią jachty w Monako i europejskie rezydencje. Nigdy się nie poddałem i pozostałem tym samym człowiekiem.",
      p2:
        "Nie interesuje mnie świat zbudowany na lęku i krytykanctwie. Tworzę z głębokiej wiary, że prostota jest aktem odwagi. Spędzam przy płótnie po 10–12 godzin dziennie, oddając sztuce całą swoją energię. Robię to po to, aby moje obrazy wnosiły światło do Twojego domu.",
      cta: "Poznaj moją historię",
    },
    works_block: {
      overline: "Wybrane prace",
      title: "Cisza, która krzyczy kolorem.",
    },
    quotes: [
      { t: "Domy bez sztuki są smutne.", a: "Piotr Gonzaga Myszkowski" },
      { t: "Sztuka jest najwyższą wibracją duszy.", a: "Piotr Gonzaga Myszkowski" },
    ],
    commission_block: {
      overline: "Sztuka na zamówienie",
      h1: "Ty masz wizję przestrzeni.",
      h2: "Ja nadaję jej wyraz.",
      p1:
        "Wierzę, że kultura i biznes muszą się wspierać. Puste ściany w domach czy urzędach odbierają energię — odpowiedni obraz potrafi ją przywrócić. Nieważne, czy to Twój pierwszy kontakt ze sztuką, czy element większego projektu inwestycyjnego. Moje zasady są niezmienne: konkret, szacunek i zaufanie.",
      p2:
        "Potrzebujesz dzieła, które dopełni Twoje wnętrze? Zostawiasz wiadomość. Spotykamy się w mojej pracowni przy filiżance doskonałej kawy. Ty opowiadasz mi o swojej przestrzeni, a ja pomagam dobrać obraz, który idealnie z nią zagra. Szanuję Twój czas — po naszej rozmowie temat jest w dobrych rękach.",
      cta: "Porozmawiajmy o sztuce",
    },
    reels: {
      overline: "Pracownia · w ruchu",
      title: "Poznaj nas. Zobacz, co teraz robimy.",
      lead:
        "Krótkie filmy z pracowni — proces, nowe płótna, codzienność Atelier Gonzaga.",
      items: [
        { t: "W pracowni", d: "Orange Zone · prace nad cyklem" },
        { t: "Detal", d: "Czystość koloru, ślad ręki" },
        { t: "Atelier", d: "Poznań · Ratajczaka 44/4" },
      ],
    },
    portrait: {
      overline: "Portret",
      caption: "Piotr Gonzaga Myszkowski · Pracownia, Poznań",
      quote:
        "Jesteśmy tylko karłami stojącymi na ramionach olbrzymów. Dlatego zawsze czerpię od największych — Matisse, Picasso, Chagall, Riviera, słońce południa.",
    },
    atelier: {
      overline: "Atelier",
      caption: "ul. Ratajczaka 44/4 · Poznań",
      line: "Wizyty wyłącznie po wcześniejszym umówieniu terminu.",
    },
    gallery: {
      overline: "Wybrane prace",
      title: "Cykle 2022 — 2024",
      lead:
        "Sześć płócien z trzech zamkniętych symfonii: Orange Zone, L'Amour, Line Art. Każdy obraz to ruch ręki, którego nie da się powtórzyć.",
      seeAll: "Zobacz pełną kolekcję",
    },
    about: {
      overline: "O mnie",
      title: "Sztuka kosztuje życie.",
      paragraph1:
        "A ja w swoją sztukę włożyłem całe swoje życie, bo uważam, że jest genialna. Tworzenie to dla mnie jak oddychanie — bez tego po prostu nie potrafię istnieć. Moja droga to absolutne poświęcenie. Pamiętam czasy, gdy malowałem wystawę „Kraina pomarańczy” z odciętym gazem i prądem, mając w kieszeni 5 złotych na cały dzień. Przyjaciele stali nade mną i mówili: „Maluj, to będzie genialne”. Nigdy się nie poddałem. Never give up.",
      paragraph2:
        "Moją największą miłością jest Francja — Lazurowe Wybrzeże, Matisse, Picasso, Chagall. Jesteśmy tylko karłami stojącymi na ramionach olbrzymów, dlatego zawsze czerpię energię od największych. To południowe słońce i czyste kolory przenoszę na płótna, które dziś wiszą w rezydencjach i na jachtach w Monako.",
      cta: "Poznaj moją historię",
      facts: [
        { k: "Lat w pracowni", v: "25+" },
        { k: "Prac w kolekcjach", v: "180+" },
        { k: "Kraje", v: "9" },
        { k: "Pracownia", v: "Poznań" },
      ],
    },
    process: {
      overline: "Mój proces",
      title: "Tworzę zamkniętymi cyklami. Całe symfonie obrazów.",
      paragraph:
        "Moja sztuka to nie jest masowa produkcja. Tworzenie to ciężka, fizyczna praca. Przychodzę do pracowni, staję przed płótnem na 8, 10 godzin dziennie i maluję, dopóki wizja nie stanie się ciałem. To wymaga tytanicznego wysiłku — i właśnie dlatego w obrazach czuć każdy ruch mojej ręki.",
      cycles: [
        {
          t: "Orange Zone",
          d: "Najnowszy rozdział. Kompletna symfonia czystej pomarańczy, złota i bieli.",
        },
        {
          t: "L'Amour",
          d: "Subtelność, miłość i absolutna perfekcja kobiecej formy.",
        },
        {
          t: "Line Art",
          d: "Sztuka wyrazu zbudowana na doskonałej, minimalistycznej prostocie.",
        },
      ],
    },
    commission: {
      overline: "Dla kogo tworzę",
      title: "Mówię otwarcie: tworzę dla elity. Ale nie dla elity portfela.",
      paragraph1:
        "Chodzi o elitę intelektualną. O ludzi, którzy mają zdrowy umysł, potrafią myśleć i przede wszystkim — czują sztukę. Domy bez sztuki są po prostu smutne. Ludzie budują wille za miliony, a w środku brakuje im energii. Mają depresję, chodzą do psychologów. A przecież prawdziwa sztuka leczy duszę.",
      paragraph2:
        "Moi klienci wiedzą, że rano, gdy wstają i patrzą na mój obraz, ich dom oddycha zupełnie inaczej. Wnosi to do wnętrza światło, daje energię i życie. Dlatego uważam, że cena za prawdziwe dzieło sztuki jest zawsze niewymierna.",
      cta: "Porozmawiajmy o sztuce dla Ciebie",
    },
    team: {
      overline: "Pracownia",
      title: "Za każdym obrazem stoi zespół.",
      lead:
        "Sam stoję przed płótnem, ale wokół mnie są ludzie, bez których ta pracownia nie istnieje. To rodzina i przyjaciele, którzy dbają o całą resztę.",
      members: [
        {
          name: "Barbara Myszkowska",
          role: "Dyrektor / żona",
          bio:
            "Moja żona i Dyrektor pracowni. Strażniczka kalendarza, finansów i tego całego porządku, którego sam bym nie utrzymał. Bez Barbary nie byłoby Atelier Gonzaga.",
        },
        {
          name: "Mateusz",
          role: "Prawa ręka",
          bio:
            "Moja prawa ręka w pracowni. Pilnuje produkcji, transportów, montaży i wszystkich detali, które dzieją się wokół malowania.",
        },
        {
          name: "Patryk",
          role: "Wsparcie techniczne",
          bio:
            "Wsparcie techniczne, fotografia obrazów, digital. Dba o to, żeby praca, która powstaje w pracowni, dotarła do świata w odpowiedniej formie.",
        },
      ],
      others:
        "Oraz wszystkie większe i mniejsze osoby — kuratorzy, galerzyści, ekipy montażowe i bliscy — dzięki którym kolejne cykle dochodzą do skutku. Dziękuję.",
    },
    exhibitions: {
      overline: "Lokalizacje",
      title: "Rezydencje i prezentacje",
      lead:
        "Stałe miejsca, w których można obejrzeć prace na żywo. Wizyty wyłącznie po wcześniejszym umówieniu terminu.",
      hqOverline: "Siedziba główna",
      atelierTitle: "Atelier Polska",
      atelierCity: "Poznań",
      atelierAddress: "ul. Ratajczaka 44/4, 61-728 Poznań",
      atelierDesc:
        "Prywatne wizyty, prezentacja najnowszych wielkoformatowych płócien oraz doradztwo w doborze dzieł do Twojego wnętrza po wcześniejszym umówieniu terminu.",
      residences: "Rezydencje",
      france: "Francja",
      monaco: "Monako",
      sainteMaxime: "Sainte-Maxime",
      sainteMaximeDesc:
        "Rezydencja twórcza i stała ekspozycja prac w rejonie Lazurowego Wybrzeża.",
      monteCarlo: "Monte Carlo",
      monteCarloDesc:
        "Riviera Palace — reprezentacja artystyczna na terenie Księstwa Monako.",
    },
    contact: {
      overline: "Napisz do mnie",
      title: "Zasługujesz na przestrzeń, która żyje energią.",
      lead:
        "Odkryj moją sztukę i poczuj to światło u siebie. Skontaktuj się ze mną lub z pracownią — zobaczmy, czy poczujesz to samo. Odpowiadamy osobiście w ciągu 48 godzin.",
      name: "Imię i nazwisko",
      email: "E-mail",
      subject: "Temat",
      message: "Wiadomość",
      send: "Wyślij wiadomość",
      sending: "Wysyłanie…",
      success: "Dziękuję. Wiadomość trafiła do pracowni.",
      error: "Coś poszło nie tak. Spróbuj ponownie.",
      direct: "Bezpośredni kontakt",
      socials: "Social media",
    },
    footer: {
      tagline: "Sztuka, która oddycha. Obrazy, które dają energię i życie.",
      rights: "Wszelkie prawa zastrzeżone.",
      madeIn: "Pracownia w Poznaniu",
    },
    gallery_page: {
      overline: "Galeria",
      title: "Każde płótno — osobne oddychanie.",
      lead:
        "Pełna kolekcja prac z ostatnich cykli. Większość obrazów żyje już w kolekcjach prywatnych — zapytaj o dostępność konkretnego dzieła.",
    },
    about_page: {
      overline: "O mnie",
      title: "Człowiek przy płótnie. I ludzie wokół niego.",
      lead:
        "Krótki życiorys, mój proces oraz zespół, który stoi za każdym obrazem.",
      bio_h: "Życiorys",
      values_h: "Wartości",
      values: [
        { t: "Bezkompromisowość", d: "Robię swoje. Zawsze robiłem swoje. Never give up." },
        { t: "Praca", d: "8 — 10 godzin dziennie przy płótnie. Bez tego sztuki nie ma." },
        { t: "Czystość koloru", d: "Słońce z południa Francji przeniesione na białe płótno." },
        { t: "Szczerość", d: "Z ludźmi rozmawiam na poziomie serca, nie ego." },
      ],
    },
    exhibitions_page: {
      overline: "Wystawy i rezydencje",
      title: "Tam, gdzie obrazy mieszkają.",
      lead:
        "Stałe miejsca prezentacji i wybrane wydarzenia. Pełna lista wystaw dostępna na życzenie.",
      timeline_h: "Kalendarium",
      events: [
        {
          y: "2024",
          t: "Orange Zone — Atelier Poznań",
          d: "Premiera najnowszego cyklu w pracowni przy Ratajczaka.",
        },
        {
          y: "2023",
          t: "Riviera Palace — Monte Carlo",
          d: "Stała ekspozycja w ramach reprezentacji w Księstwie Monako.",
        },
        {
          y: "2022",
          t: "Sainte-Maxime — Lazurowe Wybrzeże",
          d: "Rezydencja twórcza i pokaz prac w sercu Côte d'Azur.",
        },
        {
          y: "2003",
          t: "Kraina Pomarańczy — Poznań",
          d: "Wystawa malowana z odciętym prądem i gazem. Początek drogi.",
        },
      ],
    },
  },
  en: {
    nav: {
      home: "Home",
      gallery: "Gallery",
      about: "About",
      exhibitions: "Exhibitions",
      contact: "Contact",
    },
    common: {
      viewMore: "View more",
      backToTop: "Back to top",
      seeCollection: "See the collection",
      contactStudio: "Contact the studio",
      readStory: "Read my story",
      talkAboutArt: "Let's talk about art",
      askAbout: "Inquire about this work",
      year: "Year",
      medium: "Medium",
      category: "Category",
    },
    hero: {
      eyebrow: "Piotr Gonzaga Myszkowski",
      h1Line1: "Art that",
      h1Line2: "breathes.",
      lead:
        "Paintings that bring light, energy and life into a space. Minimalism, pure form, colour without compromise.",
      ctaPrimary: "Collection",
      ctaSecondary: "Studio",
      paris_caption: "Bow to Paris · oil on canvas",
    },
    manifesto: {
      overline: "Manifesto",
      lines: [
        "Art costs a lifetime.",
        "Painting is breathing.",
        "Homes without art are sad.",
        "Never give up.",
      ],
    },
    featured: {
      overline: "In the studio",
      title: "Orange Zone",
      meta: "Oil on canvas · 2024",
    },
    about_block: {
      overline: "About the artist",
      title: "True art costs a lifetime.",
      p1:
        "I gave my work everything. Over more than a quarter of a century I walked a long road — from days when I painted an exhibition with the electricity cut off, to today, when my works hang on yachts in Monaco and in European residences. I never gave up. I remained the same man.",
      p2:
        "I am not interested in a world built on fear and cynicism. I create from a deep belief that simplicity is an act of courage. I spend 10–12 hours a day at the canvas, giving art all my energy. I do it so that my paintings bring light into your home.",
      cta: "Read my story",
    },
    works_block: {
      overline: "Selected works",
      title: "Silence that screams in colour.",
    },
    quotes: [
      { t: "Homes without art are sad.", a: "Piotr Gonzaga Myszkowski" },
      { t: "Art is the highest vibration of the soul.", a: "Piotr Gonzaga Myszkowski" },
    ],
    commission_block: {
      overline: "Commissioned art",
      h1: "You have a vision of space.",
      h2: "I give it expression.",
      p1:
        "I believe culture and business must support one another. Empty walls — in homes or offices — drain energy. The right painting can restore it. Whether this is your first encounter with art, or part of a larger project, my principles are constant: directness, respect, trust.",
      p2:
        "Do you need a work that will complete your interior? You leave a message. We meet at my studio over a cup of excellent coffee. You tell me about your space, and I help you find a painting that resonates with it. I respect your time — after our conversation, the matter is in good hands.",
      cta: "Let's talk about art",
    },
    reels: {
      overline: "Studio · in motion",
      title: "Meet us. See what we are doing now.",
      lead:
        "Short films from the studio — process, new canvases, the daily life of Atelier Gonzaga.",
      items: [
        { t: "In the studio", d: "Orange Zone · work in progress" },
        { t: "Detail", d: "Pure colour, the trace of the hand" },
        { t: "Atelier", d: "Poznań · Ratajczaka 44/4" },
      ],
    },
    portrait: {
      overline: "Portrait",
      caption: "Piotr Gonzaga Myszkowski · Studio, Poznań",
      quote:
        "We are only dwarfs standing on the shoulders of giants. So I always take from the greatest — Matisse, Picasso, Chagall, the Riviera, the southern sun.",
    },
    atelier: {
      overline: "Atelier",
      caption: "ul. Ratajczaka 44/4 · Poznań",
      line: "Visits strictly by prior appointment.",
    },
    gallery: {
      overline: "Selected works",
      title: "Cycles 2022 — 2024",
      lead:
        "Six canvases from three closed symphonies: Orange Zone, L'Amour, Line Art. Each painting is a single gesture that cannot be repeated.",
      seeAll: "See the full collection",
    },
    about: {
      overline: "About",
      title: "Art costs a lifetime.",
      paragraph1:
        "And I gave my entire life to my art, because I believe it is brilliant. Painting is breathing to me — without it I simply cannot exist. My road has been one of total devotion. I remember painting the exhibition „Land of Oranges” with the gas and electricity cut off, with five złoty in my pocket for the whole day. My friends stood over me and said: „Paint. It will be brilliant.” I never gave up. Never give up.",
      paragraph2:
        "France is my greatest love — the French Riviera, Matisse, Picasso, Chagall. We are only dwarfs standing on the shoulders of giants, so I always draw my energy from the greatest. It is that southern sun and clean colour that I carry onto canvases now hanging in residences and on yachts in Monaco.",
      cta: "Read my story",
      facts: [
        { k: "Years in studio", v: "25+" },
        { k: "Works in collections", v: "180+" },
        { k: "Countries", v: "9" },
        { k: "Studio", v: "Poznań" },
      ],
    },
    process: {
      overline: "My process",
      title: "I work in closed cycles. Entire symphonies of paintings.",
      paragraph:
        "My art is not mass production. Painting is hard, physical work. I come into the studio, stand at the canvas for 8 — 10 hours a day and paint until the vision becomes flesh. It demands titanic effort — and that is exactly why every movement of my hand is visible in the work.",
      cycles: [
        {
          t: "Orange Zone",
          d: "The newest chapter. A complete symphony of pure orange, gold and white.",
        },
        {
          t: "L'Amour",
          d: "Subtlety, love and the absolute perfection of the female form.",
        },
        {
          t: "Line Art",
          d: "Expression built on perfect, minimalist simplicity.",
        },
      ],
    },
    commission: {
      overline: "Who I paint for",
      title: "I say it openly: I paint for the elite. Not the elite of money.",
      paragraph1:
        "I mean the intellectual elite. People with a healthy mind, who can think, and above all — who feel art. Homes without art are simply sad. People build mansions worth millions and still feel empty inside. They get depressed. They see therapists. And real art heals the soul.",
      paragraph2:
        "My clients know that when they get up in the morning and look at my painting, their home breathes in a completely different way. It brings in light, energy, life. That is why I believe the price of a true work of art is always immeasurable.",
      cta: "Let's talk about art for you",
    },
    team: {
      overline: "The studio",
      title: "Behind every painting there is a team.",
      lead:
        "I stand at the canvas alone — but the studio doesn't exist without the people around me. They are family and friends who carry everything else.",
      members: [
        {
          name: "Barbara Myszkowska",
          role: "Director / wife",
          bio:
            "My wife and the Director of the studio. Guardian of the calendar, the finances and all the order I could never keep on my own. Without Barbara there is no Atelier Gonzaga.",
        },
        {
          name: "Mateusz",
          role: "Right hand",
          bio:
            "My right hand in the studio. He keeps production, transport, installation and every detail that happens around the painting itself.",
        },
        {
          name: "Patryk",
          role: "Technical support",
          bio:
            "Technical support, photography of the works, digital. He makes sure the work that leaves the studio reaches the world in the right form.",
        },
      ],
      others:
        "And all the larger and smaller people — curators, gallerists, installation crews and close ones — thanks to whom each new cycle comes to life. Thank you.",
    },
    exhibitions: {
      overline: "Locations",
      title: "Residences and presentations",
      lead:
        "Permanent places where the work can be seen in person. Visits strictly by prior appointment.",
      hqOverline: "Headquarters",
      atelierTitle: "Atelier Poland",
      atelierCity: "Poznań",
      atelierAddress: "ul. Ratajczaka 44/4, 61-728 Poznań",
      atelierDesc:
        "Private viewings, presentation of the newest large-format canvases and personal advice on choosing works for your interior — by prior appointment only.",
      residences: "Residences",
      france: "France",
      monaco: "Monaco",
      sainteMaxime: "Sainte-Maxime",
      sainteMaximeDesc:
        "Creative residence and a permanent exhibition of works on the French Riviera.",
      monteCarlo: "Monte Carlo",
      monteCarloDesc:
        "Riviera Palace — artistic representation in the Principality of Monaco.",
    },
    contact: {
      overline: "Write to me",
      title: "You deserve a space that lives with energy.",
      lead:
        "Discover my work and feel that light at home. Get in touch with me or the studio — let's see if you feel the same. We reply personally within 48 hours.",
      name: "Full name",
      email: "Email",
      subject: "Subject",
      message: "Message",
      send: "Send message",
      sending: "Sending…",
      success: "Thank you. Your message has reached the studio.",
      error: "Something went wrong. Please try again.",
      direct: "Direct contact",
      socials: "Social media",
    },
    footer: {
      tagline: "Art that breathes. Paintings that give you energy and life.",
      rights: "All rights reserved.",
      madeIn: "Studio in Poznań",
    },
    gallery_page: {
      overline: "Gallery",
      title: "Each canvas — its own breath.",
      lead:
        "The full body of recent cycles. Most paintings already live in private collections — ask about the availability of a specific piece.",
    },
    about_page: {
      overline: "About",
      title: "A man at the canvas. And the people around him.",
      lead:
        "A short biography, my process and the team that stands behind every painting.",
      bio_h: "Biography",
      values_h: "Values",
      values: [
        { t: "No compromise", d: "I do my own thing. I have always done my own thing. Never give up." },
        { t: "Work", d: "8 — 10 hours a day at the canvas. Without it, art doesn't happen." },
        { t: "Pure colour", d: "Sunlight from the south of France carried onto white canvas." },
        { t: "Honesty", d: "I speak with people heart to heart, not ego to ego." },
      ],
    },
    exhibitions_page: {
      overline: "Exhibitions & residences",
      title: "Where the paintings live.",
      lead:
        "Permanent presentation venues and selected events. The full exhibition list is available on request.",
      timeline_h: "Timeline",
      events: [
        {
          y: "2024",
          t: "Orange Zone — Atelier Poznań",
          d: "Premiere of the newest cycle at the studio on Ratajczaka.",
        },
        {
          y: "2023",
          t: "Riviera Palace — Monte Carlo",
          d: "Permanent exhibition as part of representation in the Principality of Monaco.",
        },
        {
          y: "2022",
          t: "Sainte-Maxime — French Riviera",
          d: "Creative residence and a presentation of works in the heart of Côte d'Azur.",
        },
        {
          y: "2003",
          t: "Land of Oranges — Poznań",
          d: "An exhibition painted with the electricity and gas cut off. The beginning of the road.",
        },
      ],
    },
  },
};
